var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriptionStatusTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 49,
    viewBox: "0 0 110 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.9452 20.0554V32.1619C79.9452 35.1039 77.5614 37.8217 74.6148 38.2334L43.6028 42.5526V48.2444C31.8897 46.0803 24.3037 45.5861 24.3037 39.9126V27.8061C24.3037 24.8641 26.6875 22.1463 29.6341 21.7346L74.6148 15.4708C77.5614 15.059 79.9452 17.1134 79.9452 20.0554Z",
    fill: "#002D4D"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M50.0792 36.2713V41.7526L43.605 42.6539C43.605 40.8467 44.8998 37.5341 50.0792 36.2713Z",
    fill: "url(#paint0_linear_61_6125)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4214 11.5686V20.7057C36.4214 22.9294 38.2241 24.4804 40.4477 24.1693L79.755 18.6971V22.9934C88.5993 18.8939 94.3277 16.9264 94.3277 12.6439V3.50222C94.3277 1.28315 92.525 -0.267914 90.3013 0.0386377L40.4477 6.9841C38.2241 7.29522 36.4214 9.345 36.4214 11.5686Z",
    fill: "#16A665"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M74.8682 15.2381V19.3743L79.7547 18.6971C79.7547 17.3291 78.7756 15.1009 74.8682 15.2381Z",
    fill: "url(#paint1_linear_61_6125)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7933 15.1283L11.7598 19.0311V18.0062L39.7933 14.0988V15.1283Z",
    fill: "#16A665"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.156 14.8309L81.1274 18.7383V17.7089L109.156 13.806V14.8309Z",
    fill: "#16A665"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4996 33.0547L65.4707 36.9575V35.9326L93.4996 32.0253V33.0547Z",
    fill: "#002D4D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0289 40.4899L0 44.3927V43.3678L28.0289 39.4604V40.4899Z",
    fill: "#002D4D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_6125",
    x1: 1072.02,
    y1: -15034.1,
    x2: 133.787,
    y2: -15534.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_61_6125",
    x1: 11317.6,
    y1: -1560.83,
    x2: 11852.3,
    y2: -1995.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionStatusTag);
export default __webpack_public_path__ + "static/media/subscriptionStatusTag.fbbfded269b588acc829ccd9e9396ab2.svg";
export { ForwardRef as ReactComponent };